export default "__VITE_ASSET__e06f01dd__"